import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    // Don't scroll to top on language change
    if (location.state?.isLanguageChange) {
      return;
    }
    window.scrollTo(0, 0);
  }, [location.pathname, location.state]);

  return null;
};
